import { Link } from "react-router-dom";

// css
import "./about.css";
// other
import aboutBG from "assets/Images/bg/aboutBG.png";
import ourStory from "assets/Images/bg/ourStory.png";
import about_sec2 from "assets/Images/bg/about_sec2_img.png";
// import userabout from "assets/Images/icons/userabout.png";
// import quote from "assets/Images/icons/quote.png";
import careIcon from "assets/Images/icons/care.png";
import efficiencyIcon from "assets/Images/icons/efficiency.png";
import excellenceIcon from "assets/Images/icons/excellence.png";
import exploreAout from "assets/Images/bg/exploreAout.png";
import { Slide, Fade } from "react-reveal";
import { Helmet } from "react-helmet";

// THIS IS A ABOUT PAGE
const About = () => {
  return (
    <>
       <Helmet>
        <title>Cyan | About</title>
      </Helmet>
      <div
        className="about_us_top_sec overflow-hidden"
        style={{ backgroundImage: `url(${aboutBG})` }}
      >
        <div className="cs_container overflow-hidden">
          <Slide left cascade>
            <div className="about_us_top_content ">
              <h5>About us</h5>
              <h1>CYAN</h1>
              <p>
                Our vision is to provide high-quality boat services accross the
                world by simplifying the booking process. <br />
                We know there are many sea lovers out there who value a great
                experience of spending a holiday by the soothing sound of the
                waves. <br />
                To all of them, we are determined to offer an unforgettable
                experience from the very first click on our website. <br />
              </p>
              <Link to="/" className="btn btn-outline-light">
                Welcome to cyan
              </Link>
            </div>
          </Slide>
        </div>
      </div>
      {/* <div className="cs_container my-md-5 my-2 py-md-5 py-3">
        <div className="our-story-head">
          <Slide bottom>
            <h2 className="text-pr">Our Story</h2>
          </Slide>
        </div>
      </div> */}
      <div className="my-5 py-5">
      <Fade bottom>
        <img className="our-stor-img mt-5 mb-5" src={ourStory} alt="" />
      </Fade>
      </div>
      <div className="about_trip_Sec">
        <div className="cs_container">
          <div className="about_trip_left overflow-hidden">
            <Slide left>
              <h5>CYAN</h5>
              <h3>Who we are</h3>
              <br />
              <p>
              We are a group of passionate Entrepreneurs inspired by the unique beauty of Greece and the endless possibilities of technology and innovation. 
              <br/>
Their combination lies at the heart of our firm belief that booking a yacht can be a simple and gratifying experience.  
<br/>
              </p>
            </Slide>
            <br />
         <p className="text-white mt-3">
         Booking a yacht can be easier than ordering a pizza.
         </p>
          </div>
          <div className="about_trip_right">
            <Fade>
              <img src={about_sec2} alt="" />
            </Fade>
          </div>
        </div>
      </div>
      {/* <div className="cs_container pt-md-5 mb-md-5 mb-3 pb-md-5 pb-2">
                <div className="about_quote_Sec">
                    <div className="about_quote_Sec_left">
                        <div className="quote_about_co_img" style={{
                            backgroundImage: `url(${userabout})`
                        }}>
                        </div>
                        <h3 className="text-pr text-center py-3">Will smith</h3>
                        <p className="text-sec text-center">Co-Founder</p>
                    </div>
                    <div className="about_quote_Sec_right">
                        <div className="quote_heading_head">
                            <h3>We don't just want to create good Booking System but</h3>
                        </div>
                        <p className="text-secondary">We are dedicated to creating world-leading systems that help to tangibly improve the industry – whether that’s by reducing emissions, or giving you peace of mind on a daily basis</p>
                        <img className="quote-img" src={quote} alt="" />
                    </div>
                </div>
            </div> */}
      <div className="cs_container overflow-hidden  py-md-4 py-3">
        <Slide bottom>
          <div className="our-story-head center-head-line mb-md-5 mb-3">
            <h2 className="text-pr">Our Values</h2>
          </div>
        </Slide>
        <Slide bottom cascade>
          <div className="our-approach-row">
            <div className="our-approach-item">
              {/* <div className="icon-box"> */}
                <img src={careIcon} className="img-fluid" alt="Easy to use" />
              {/* </div> */}
              <h4 className="text-pr">Care</h4>
            </div>
            <div className="our-approach-item">
              {/* <div className="icon-box"> */}
                <img src={efficiencyIcon} alt="Booking system" />
              {/* </div> */}
              <h4 className="text-pr">Efficiency</h4>
             
            </div>
            <div className="our-approach-item">
              {/* <div className="icon-box"> */}
                <img src={excellenceIcon} alt="Manage trips" />
              {/* </div> */}
              <h4 className="text-pr">Excellence</h4>
            </div>
          </div>
        </Slide>
      </div>
      <div
        className="about-explore-sec mb-5 mt-md-4 mt-2"
        style={{ backgroundImage: `url(${exploreAout})` }}
      >
        <Slide bottom>
          <div className="cs_container explore-content">
            <h2>Book your yacht in 4 steps</h2>
            <p>
            Choose from a wide range of eclectic yachts and start your journey
            </p>
            <Link to="/" className="btn btn-outline-light">
              Join now
            </Link>
          </div>
        </Slide>
      </div>
    </>
  );
};

export default About;
